import { useIsMutating } from "@tanstack/react-query";

export const useIsDeletingResource = ({
  resource,
  id,
}: {
  resource: string;
  id: string;
}) => {
  const count = useIsMutating({
    mutationKey: [resource, "delete"],
    predicate: (mutation) => {
      return mutation.state.variables.id === id;
    },
  });

  return count > 0;
};
